'use client';

import useVelocityAccountStore from 'src/stores/useVelocityAccountsStore';
import { getSubscribedClient } from 'src/utils/account';

const useUserAccountIsReady = (userKey?: string) => {
	const userAccountIsReady = useVelocityAccountStore((s) => {
		// Selecting a boolean rather than the account itself is a perf improvement:
		// avoids rerenders unless readiness actually flips.
		return Boolean(
			getSubscribedClient(s.accounts[userKey ?? s.currentUserKey ?? ''])
		);
	});

	return userAccountIsReady;
};

export default useUserAccountIsReady;
